import "./CardBlocksSection.scss";
import CardBlock from "../../components/CardBlock/CardBlock";

function CardBlocksSection({ cards = [], variant = "default" }) {
    return (
        <section className="card-blocks-section">
            <div className="card-blocks-section__section-wrapper">
                <div className="card-blocks-section__grid">
                    {cards.map((card, index) => (
                        <CardBlock
                            key={card.id ?? index}
                            variant={card.variant ?? variant}
                            icon={card.icon}
                            image={card.image}
                            imageAlt={card.imageAlt}
                            title={card.title}
                            body={card.body}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}

export default CardBlocksSection;
